import { FilterItem } from '@/modules/accredited-establishments/api/types'

export const DEFAULT_LAT = '-23.570036'
export const DEFAULT_LON = '-46.658986'

export const DEFAULT_PLACE_LABEL = 'São Paulo, SP, Brasil'
export const DEFAULT_PLACE_ID = 'ChIJ0WGkg4FEzpQRrlsz_whLqZs'
export const DEFAULT_ADDRESS: FilterItem = {
  title: DEFAULT_PLACE_LABEL,
  value: DEFAULT_PLACE_ID
}

export const DEFAULT_RADIUS_IN_METERS = 15000
export const MAX_RADIUS_IN_METERS = 25000
export const CLUSTER_RADIUS_IN_METERS = 3

export const DEFAULT_ZOOM = 14
export const MIN_ZOOM = 12

export const CHANGE_ADDRESS_DEBOUNCE_TIME = 500

export const CATEGORIES_PARAMS = 'categorias'
export const SPECIALTY_PARAMS = 'especialidade'
export const SUB_SPECIALTY_PARAMS = 'subespecialidade'
export const GENDER_PARAMS = 'genero'
export const APPOINTMENT_TYPE_PARAMS = 'atendimento'
export const PROVIDER_NAME_PARAMS = 'nome_prestador'
export const PLAN_PARAMS = 'plano'
export const ADDRESS_PARAMS = 'localidade'
export const ADDRESS_SEARCH_PARAMS = 'busca_localidade'

/* Seis linhas do grid de tres colunas do desktop. */
export const ITEMS_PER_PAGE = 18
export const DEFAULT_PAGINATION_OFFSET = 0
/*
 * O `range` da API e inclusivo (`[0, 17]` traz 18 itens), entao o limite da
 * primeira pagina e o ultimo indice dela.
 */
export const DEFAULT_PAGINATION_LIMIT = ITEMS_PER_PAGE - 1
export const SPECIALIST_PARAMS = 'especialista'

export const ESTABLISHMENT_PARAMS = 'estabelecimento'

export const SEALED_FILTERS_PARAM = 'f'

export const SEALED_FILTER_KEYS = [
  SPECIALTY_PARAMS,
  SUB_SPECIALTY_PARAMS,
  GENDER_PARAMS,
  APPOINTMENT_TYPE_PARAMS,
  PLAN_PARAMS,
  ADDRESS_PARAMS,
  ADDRESS_SEARCH_PARAMS,
  PROVIDER_NAME_PARAMS,
  CATEGORIES_PARAMS,
  SPECIALIST_PARAMS,
  ESTABLISHMENT_PARAMS
] as const
